import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreSetupAuditTrailSectionsSlice } from './get';

export const coreSetupAuditTrailSectionsReducers = combineReducers({
	get: getCoreSetupAuditTrailSectionsSlice.asyncReducers
});

export const coreSetupAuditTrailSectionsWatchers = combineAllWatchers([
	getCoreSetupAuditTrailSectionsSlice.asyncWatchers
]);
